import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-broadcasts-list',
  templateUrl: './broadcasts-list.component.html',
  styleUrls: ['./broadcasts-list.component.scss']
})
export class BroadcastsListComponent implements OnInit, OnDestroy {

  broadcasts: any[] = [];
  pagination = { page: 1, pageSize: 10, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };
  private socketSub?: Subscription;

  formGroup = new FormGroup({
    search: new FormControl(''),
    sent_from: new FormControl(''),
    sent_until: new FormControl(''),
    status: new FormControl(''),
    priority: new FormControl(''),
  });

  constructor(public okService: OkAloneService, private router: Router) { }

  ngOnInit(): void {
    this.pagination.page = 1;
    this.loadBroadcasts();
    this.socketSub = this.okService.getBroadcastRefreshEmitter().subscribe(() => {
      this.loadBroadcasts();
    });
  }

  ngOnDestroy(): void {
    this.socketSub?.unsubscribe();
  }

  loadBroadcasts(): void {
    const filter: any = {
      page: this.pagination.page,
      expand: 'sender',
      search: this.formGroup.value.search,
      sent_from: this.formGroup.value.sent_from,
      sent_until: this.formGroup.value.sent_until,
      status: this.formGroup.value.status,
      priority: this.formGroup.value.priority,
    };

    Object.keys(filter).forEach((key) => {
      if (filter[key] === '' || filter[key] === null) {
        delete filter[key];
      }
    });

    this.okService.get('broadcasts', filter).subscribe((data) => {
      this.broadcasts = (data.body as any[]) || [];
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;
    });
  }

  updateFilter(): void {
    this.pagination.page = 1;
    this.loadBroadcasts();
  }

  changePage(): void {
    this.loadBroadcasts();
  }

  createBroadcast(): void {
    this.router.navigate(['/mgmt/broadcasts/new']);
  }

  viewBroadcast(broadcast: any): void {
    if (broadcast.status === 'draft') {
      this.router.navigate(['/mgmt/broadcasts', broadcast.id, 'edit']);
      return;
    }
    this.router.navigate(['/mgmt/broadcasts', broadcast.id]);
  }

  deleteBroadcast(broadcast: any): void {
    if (broadcast.status !== 'draft') {
      return;
    }
    this.okService.delete('broadcasts/' + broadcast.id).subscribe(() => {
      this.loadBroadcasts();
    });
  }

  exportBroadcast(id: number): void {
    this.okService.download('broadcasts/' + id + '/export', {});
  }

  priorityBadgeClass(priority: string): string {
    return priority === 'critical' ? 'bg-danger' : 'bg-primary';
  }

  statusBadgeClass(status: string): string {
    if (status === 'sent') {
      return 'bg-success';
    }
    if (status === 'sending') {
      return 'bg-warning text-dark';
    }
    return 'bg-secondary';
  }

  statusBadgeIcon(status: string): string {
    if (status === 'sent') {
      return 'fa-circle-check';
    }
    if (status === 'sending') {
      return 'fa-paper-plane';
    }
    return 'fa-pen-to-square';
  }

  initials(name: string): string {
    if (!name) {
      return '?';
    }
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }
}
